import React, { Fragment, useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import { storage, db } from "../../../../firebase";
import { ref, getDownloadURL, deleteObject, listAll } from "firebase/storage";
import { getDoc, doc } from "firebase/firestore";

export default ({
  name,
  label,
  type,
  value,
  initailValue,
  onChange,
  options,
  disabled,
  required,
  description,
  fileNames,
  defaultfiles,
  onViewFile,
  product,
  ticketId,
  viewonly,
  onProductFound,
}) => {
  const onSearch = async (e) => {
    e.preventDefault();

    try {
      // Search in cpaps collection using serial number as document ID
      const cpapDoc = await getDoc(doc(db, "cpaps", product));

      if (cpapDoc.exists()) {
        const cpapData = cpapDoc.data();

        if (onProductFound) {
          const dataToSend = {
            hn: cpapData.LastHN || "",
            brand: cpapData.Brand || "",
            model: cpapData.Model || "",
            cpapType: cpapData.Type || "",
          };

          onProductFound(dataToSend);
        }
      } else {
        alert("No CPAP found with this serial number");
      }
    } catch (error) {
      console.error("Error searching CPAP:", error);
      alert("Error searching CPAP device");
    }
  };

  return (
    <div className="form-group row m-1">
      <label label className="col-lg-4 col-form-label">
        {label}
        {required && <span className="text-danger">*</span>}
      </label>

      <div className="col-lg-6">
        {type === "select" ? (
          <div>
            <select
              key={name}
              className="form-control"
              defaultValue={initailValue}
              onChange={onChange}
              disabled={disabled || viewonly}
            >
              {!initailValue && <option value={null}>please-select</option>}
              {options.map((opt) => (
                <option value={opt}>{opt}</option>
              ))}
            </select>
            <span className="text-danger">
              <small>{description}</small>
            </span>
          </div>
        ) : type === "text" || type === "number" ? (
          <div>
            {name === "hn" ? (
              <input
                key={name}
                className="form-control"
                type={type}
                name={name}
                value={value}
                onChange={onChange}
                disabled={disabled || viewonly}
                required={required}
              />
            ) : value !== undefined && value !== null && value !== "" ? (
              <input
                key={name}
                className="form-control"
                type={type}
                name={name}
                value={value}
                onChange={onChange}
                disabled={disabled || viewonly}
                required={required}
              />
            ) : (
              <input
                key={name}
                className="form-control"
                type={type}
                name={name}
                defaultValue={initailValue}
                onChange={onChange}
                disabled={disabled || viewonly}
                required={required}
              />
            )}
            <small>{description}</small>
          </div>
        ) : type === "date" || type === "time" ? (
          <>
            {value !== undefined && value !== null && value !== "" ? (
              <input
                key={name}
                className="form-control"
                placeholder="dd-mm-yyyy"
                type={type}
                name={name}
                value={value}
                onChange={onChange}
                disabled={disabled || viewonly}
                required={required}
              />
            ) : (
              <input
                key={name}
                className="form-control"
                placeholder="dd-mm-yyyy"
                type={type}
                name={name}
                defaultValue={initailValue}
                onChange={onChange}
                disabled={disabled || viewonly}
                required={required}
              />
            )}
          </>
        ) : type === "textarea" ? (
          <textarea
            key={name}
            className="form-control"
            type={type}
            name={name}
            rows={"3"}
            onChange={onChange}
            defaultValue={initailValue}
            disabled={disabled || viewonly}
            required={required}
          />
        ) : type === "file" ? (
          <div className="basic-form custom_file_input">
            <div className="input-group">
              <div className="custom-file">
                <input
                  key={name}
                  type="file"
                  multiple
                  className="custom-file-input"
                  onChange={onChange}
                  disabled={disabled || viewonly}
                />

                {fileNames.length > 0 ? (
                  <label className="custom-file-label">{fileNames}</label>
                ) : (
                  <label className="custom-file-label">choose file</label>
                )}
              </div>
            </div>
            {defaultfiles.length > 0 &&
              defaultfiles.map((item) => {
                return (
                  <span className="text-info">
                    <Link
                      key={item}
                      to="#"
                      onClick={() => onViewFile(ticketId, item)}
                    >
                      <small>{item}</small>
                    </Link>
                  </span>
                );
              })}
          </div>
        ) : type === "radio" ? (
          <div className="basic-form">
            {options.map((opt) => (
              <div key={opt} className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name={name}
                  value={opt}
                  onChange={onChange}
                  defaultChecked={initailValue === opt}
                />
                <label className="form-check-label">{opt}</label>
              </div>
            ))}
            <span className="text-danger">
              <small>{description}</small>
            </span>
          </div>
        ) : type === "search" ? (
          <div className="basic-form d-flex">
            {value !== undefined && value !== null && value !== "" ? (
              <input
                key={name}
                className="form-control mr-2"
                type="text"
                name={name}
                value={value}
                onChange={onChange}
                disabled={disabled || viewonly}
                required={required}
              />
            ) : (
              <input
                key={name}
                className="form-control mr-2"
                type="text"
                name={name}
                defaultValue={initailValue}
                onChange={onChange}
                disabled={disabled || viewonly}
                required={required}
              />
            )}
            <button className="btn btn-primary btn-sm" onClick={onSearch}>
              Search
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );
};
